export default __webpack_public_path__ + "static/media/ThankYou.fbf5b362.png";